"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormStatus = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
var FormStatus = function (_a) {
    var livestream = _a.livestream, setLivestream = _a.setLivestream, video = _a.video, setVideo = _a.setVideo;
    function auto(auto) {
        setLivestream({ auto: auto, video: __assign(__assign({}, video), { hidden: !auto }) });
        ra_fetch_1.Fetcher.api('backend').update('livestreams.auto', {
            id: livestream.id,
            auto: auto,
            channel_id: livestream.channel_id,
        });
    }
    function hide(hidden) {
        hidden = hidden ? 1 : 0;
        setVideo({ hidden: hidden });
        ra_fetch_1.Fetcher.api('backend').update('channels.tag.update', {
            channel_id: livestream.channel_id,
            id: livestream.channel_id,
            video_id: video.id,
            livestream_id: livestream.id,
            hidden: hidden,
        });
    }
    return react_1.default.createElement(storybook_1.Cards.Card, { className: 'storybook-videos-form-status' },
        react_1.default.createElement(storybook_1.Cards.Content, null,
            react_1.default.createElement("div", { className: 'storybook-videos-form-status-title' },
                react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3' }, "Status wijzigen"),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(storybook_1.Texts.Span, { className: 'storybook-forms-status-label' }, "Publiek"),
                    react_1.default.createElement(storybook_1.Forms.Toggle, { disabled: !livestream.auto && !video.hidden, value: livestream.auto, onClick: function () { return auto(!livestream.auto); } }))),
            !livestream.auto &&
                react_1.default.createElement(storybook_1.Buttons.Button, { className: 'storybook-livestreams-form-status', onClick: function () { return hide(!video.hidden); }, disabled: video.status !== 'published', type: 'secondary' }, livestream.video.hidden ? 'NU LIVE GAAN' : 'LIVESTREAM VERBERGEN'),
            react_1.default.createElement(storybook_1.Texts.Small, { className: "mt-4" }, "Zet de livestream op publiek om automatisch live te gaan wanneer Eyecons een inkomende stream ontvangt.")));
};
exports.FormStatus = FormStatus;
exports.FormStatus.propTypes = {
    livestream: prop_types_1.default.object.isRequired,
    setLivestream: prop_types_1.default.func.isRequired,
};
